import React, { useEffect, useState } from "react";
import BackButton from "../components/BackButton";

const s = {
  wrapper: { minHeight: "100svh", background: "#f3f4f6", padding: "16px 16px 40px", boxSizing: "border-box", fontFamily: "system-ui, -apple-system, sans-serif" },
  inner: { maxWidth: "680px", margin: "0 auto" },
  card: { background: "white", borderRadius: "16px", boxShadow: "0 4px 24px rgba(0,0,0,0.07)", border: "1px solid #f1f5f9", padding: "24px 20px", marginBottom: "12px" },
  h1: { fontSize: "22px", fontWeight: 800, color: "#1e293b", margin: "0 0 4px" },
  tagline: { fontSize: "13px", color: "#64748b", margin: "0" },
  waveBadge: { display: "inline-block", fontSize: "11px", fontWeight: 700, color: "#e11d48", background: "#fff1f2", borderRadius: "20px", padding: "3px 10px", marginBottom: "6px" },
  waveTitle: { fontSize: "18px", fontWeight: 800, color: "#1e293b", margin: "0 0 4px" },
  waveIntro: { fontSize: "13px", color: "#64748b", lineHeight: 1.6, margin: "0 0 16px" },
  sectionLabel: { fontSize: "12px", fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em", margin: "16px 0 8px" },
  highlight: { display: "flex", alignItems: "flex-start", gap: "8px", padding: "8px 0", borderBottom: "1px solid #f8fafc" },
  highlightLast: { display: "flex", alignItems: "flex-start", gap: "8px", padding: "8px 0" },
  highlightText: { fontSize: "14px", color: "#475569", lineHeight: 1.55, flex: 1 },
  detailItem: { fontSize: "13px", color: "#64748b", lineHeight: 1.6, padding: "3px 0" },
  toggleBtn: { display: "flex", alignItems: "center", gap: "6px", background: "none", border: "none", cursor: "pointer", color: "#e11d48", fontWeight: 700, fontSize: "13px", padding: "10px 0 2px", width: "100%" },
  chevron: { fontSize: "13px", display: "inline-block", transition: "transform 0.18s ease", userSelect: "none" },
  detailBox: { paddingTop: "6px", paddingLeft: "4px" },
  separator: { border: "none", borderTop: "2px dashed #e2e8f0", margin: "8px 0 20px" },
  footer: { fontSize: "13px", color: "#94a3b8", textAlign: "center", marginTop: "8px", lineHeight: 1.6 },
};

const WAVES = [
  {
    id: "w-may",
    badge: "v1.0.10 -> v1.0.14 · 8 mai -> 14 mai",
    emoji: "🔒",
    title: "Mai 2026 — Notifications intelligentes & stabilité",
    intro: "Une semaine consacrée à rendre les notifications vraiment utiles : seuls les clients du bon magasin sont notifiés. Plus de spam, plus de pertinence. Notifications push Android désormais fonctionnelles.",
    sections: [
      {
        id: "wmay-clients",
        emoji: "🛒",
        title: "Pour vous",
        highlights: [
          { icon: "🔔", label: "Notifications géolocalisées", desc: " — vous recevez uniquement les alertes des magasins où vous avez scanné le produit" },
          { icon: "🔧", label: "Bannière de maintenance", desc: " — un indicateur discret vous prévient quand des améliorations sont en cours" },
          { icon: "⚡", label: "Produits mieux reconnus", desc: " — le scanner trouve maintenant les produits plus rapidement grâce à un délai de recherche doublé" },
        ],
      },
      {
        id: "wmay-vendeurs",
        emoji: "🏪",
        title: "Pour les vendeurs",
        highlights: [
          { icon: "✅", label: "Validation superadmin", desc: " — votre compte doit être validé avant que vos notifications soient envoyées" },
          { icon: "🏬", label: "Magasin lié automatiquement", desc: " — vos produits sont automatiquement associés à votre magasin vérifié" },
          { icon: "🔔", label: "Notifications ciblées", desc: " — seuls vos vrais clients locaux reçoivent vos alertes produit" },
        ],
      },
      {
        id: "wmay-tech",
        emoji: "🔧",
        title: "Sous le capot",
        highlights: [
          { icon: "🗺️", label: "store_id dans les scans", desc: " — chaque scan est maintenant associé au magasin le plus proche (rayon 500m)" },
          { icon: "🔍", label: "Filtre FCM par magasin", desc: " — les notifications ne partent qu'aux clients ayant scanné dans le bon magasin" },
          { icon: "⚡", label: "Cache d'échecs réduit", desc: " — de 10 à 2 minutes pour les produits non trouvés, relance plus rapide" },
          { icon: "🛡️", label: "Rate limiter étendu", desc: " — les routes admin exemptées pour éviter les blocages 429" },
        ],
      },
    ],
  },
  {
    id: "w0",
    badge: "v1.0.8 -> v1.0.9 · 30 avril -> 2 mai",
    emoji: "🌺",
    title: "Mai 2026 — Stabilisation & persistance",
    intro: "Une semaine intense de polissage, de corrections ciblées et d'une victoire technique majeure : l'app reste maintenant connectée comme WhatsApp.",
    sections: [
      {
        id: "w0-clients",
        emoji: "🛒",
        title: "Pour vous",
        highlights: [
          { icon: "🔐", label: "Tu restes connecté", desc: " — ferme l'app, réouvre-la : tu es toujours là. Fini les reconnexions à répétition sur Honor, Huawei, Xiaomi et tous les navigateurs" },
          { icon: "💡", label: "FAQ disponible", desc: " — 19 questions/réponses accessibles depuis ton profil pour tout comprendre sur CrushNow" },
          { icon: "📋", label: "Journal des évolutions", desc: " — cette page ! Pour suivre ce qui change à chaque version" },
          { icon: "🔔", label: "Alertes plus fiables", desc: " — le bouton alerte est mieux visible et plus stable sur tous tes Crushs" },
          { icon: "←", label: "Bouton retour", desc: " — present sur toutes les pages pour naviguer sans se perdre" },
        ],
      },
      {
        id: "w0-vendeurs",
        emoji: "🏪",
        title: "Pour les vendeurs",
        highlights: [
          { icon: "⚡", label: "Tableau de bord plus rapide", desc: " — les compteurs de scans ne bloquent plus le chargement (erreur 429 corrigée)" },
          { icon: "🔐", label: "Session persistante", desc: " — même avantage que pour les clients, vous restez connectés" },
        ],
      },
      {
        id: "w0-tech",
        emoji: "🔧",
        title: "Sous le capot",
        highlights: [
          { icon: "🛡️", label: "Session restoration", desc: " — l'app vérifie votre token au démarrage via /auth/me avant d'afficher quoi que ce soit" },
          { icon: "⚡", label: "Rate limiter ajusté", desc: " — 30 -> 100 requêtes/min pour absorber les tableaux produits chargés" },
          { icon: "🔀", label: "Redirection intelligente", desc: " — si vous êtes connecté et arrivez sur la landing, l'app vous redirige automatiquement vers votre espace" },
          { icon: "🔒", label: "Erreurs réseau", desc: " — une coupure WiFi au démarrage ne vous déconnecte plus (seul un token expiré le fait)" },
        ],
      },
    ],
  },
  {
    id: "w1",
    badge: "v1.0.0 -> v1.0.8 · 18 avril -> 30 avril",
    emoji: "🌸",
    title: "Avril 2026 — Lancement officiel",
    intro: "CrushNow est officiellement entré dans sa phase de lancement. Un mois intense de polissage, de sécurité, et de premières mises en main par les testeurs.",
    sections: [
      {
        id: "w1-clients",
        emoji: "🛒",
        title: "Pour vous",
        highlights: [
          { icon: "💡", label: "Une FAQ est arrivée", desc: " — 19 questions/réponses pour t'aider à mieux comprendre l'app, accessible depuis ton profil" },
          { icon: "📦", label: "Fiche produit enrichie", desc: " — marque, catégorie traduite, lieu et date du scan, prix, statut, tout sur une seule page" },
          { icon: "🔔", label: "Bouton alerte plus visible et plus fiable", desc: " sur tous tes Crushs" },
          { icon: "📷", label: "Scanner redessiné", desc: " — fond sombre, viseur doré, caméra arrière par défaut, libellés en français" },
          { icon: "🗺️", label: "Filtres historique", desc: " — trie tes Crushs par En attente, En promo, Indisponible" },
          { icon: "👤", label: "Deux modes de compte", desc: " — classique avec email, ou anonyme avec 12 mots de récupération" },
          { icon: "🔒", label: "Vérification email à l'inscription", desc: " pour sécuriser ton compte" },
          { icon: "🎯", label: "Système XP et badges", desc: " — Système de progression persistant : 7 niveaux (Curieux → Légende), 12 badges, XP gagné par scan, achat, partage et contribution communautaire. Progression sauvegardée en ligne." },
          { icon: "🌐", label: "Nouveau domaine", desc: " — bienvenue sur crush-now.fr" },
        ],
        details: [
          "Page Mes données RGPD avec export complet",
          "Suppression de compte avec double confirmation",
          "Récupération de compte (email ou pseudonyme) sur une seule page",
          "Mot de passe oublié par email",
          "Toggle afficher/masquer le mot de passe",
          "Bandeau cookies conforme RGPD",
          "Modal d'accueil au premier lancement",
          "Notice « Comment ça marche » repensée (5 cartes)",
          "Fiches produits communautaires : ajoute toi-même les produits manquants",
          "Photo produit possible (jusqu'à 5 Mo)",
          "Catégories de produits traduites en français",
          "Bouton retour qui ramène à la page précédente, pas à l'accueil",
          "Liens légaux (CGU, Confidentialité, Mentions légales) sans rechargement",
        ],
      },
      {
        id: "w1-vendeurs",
        emoji: "🏪",
        title: "Pour les vendeurs",
        highlights: [
          { icon: "📊", label: "Dashboard repensé", desc: " — navigation par onglets, section profil dédiée" },
          { icon: "🔔", label: "Notifications push automatiques", desc: " — vos clients abonnés sont prévenus dès que vous modifiez un produit" },
          { icon: "🏬", label: "Onglet Mon Magasin", desc: " — référencez votre point de vente avec autocomplete d'adresse" },
          { icon: "✅", label: "Système de validation magasin", desc: " — Bronze, Silver, Gold selon vos vérifications" },
          { icon: "📦", label: "Référencement de produits par code-barres", desc: " débloqué (MVP)" },
          { icon: "💰", label: "Prix communautaires", desc: " affichés via Open Prices" },
        ],
        details: [
          "Tableau magasins responsive",
          "Onglet Feedbacks pour suivre les retours utilisateurs",
          "Édition rapide des produits via la fiche produit",
          "Géocodage SIRENE pour les commerces officiels",
          "Statistiques d'engagement par produit (scans, alertes actives)",
        ],
      },
      {
        id: "w1-tech",
        emoji: "🔧",
        title: "Sous le capot",
        highlights: [
          { icon: "🛡️", label: "Audit sécurité complet", desc: " — 40 failles identifiées, 25+ corrigées (tag v1.0.1-security)" },
          { icon: "🔐", label: "Conformité RGPD", desc: " — purge automatique 24 mois, rate limiting, protection brute force, logs nettoyés" },
          { icon: "📱", label: "Application Android publiée en test fermé Play Store", desc: "" },
          { icon: "⚡", label: "Migration Firebase Cloud Messaging native", desc: " pour des notifications plus fiables" },
          { icon: "🖥️", label: "Sessions sécurisées", desc: " — JWT durcis, contrôles d'accès renforcés sur toutes les routes sensibles" },
        ],
      },
    ],
  },
  {
    id: "w2",
    badge: "Branche barcode-v2 · 17 mars -> 31 mars",
    emoji: "🌱",
    title: "Mars 2026 — La grande refonte",
    intro: "La naissance de CrushNow tel que vous le connaissez aujourd'hui. Tout a été repensé autour du scan de code-barres, avec une expérience client et vendeur entièrement nouvelle.",
    sections: [
      {
        id: "w2-clients",
        emoji: "🛒",
        title: "Pour vous",
        highlights: [
          { icon: "📷", label: "Scan de code-barres", desc: " — la fonctionnalité au cœur de CrushNow" },
          { icon: "🏠", label: "Refonte complète de l'accueil", desc: " — page d'accueil, historique, carte, profil" },
          { icon: "💜", label: "Notion de Crush", desc: " — ton vocabulaire pour parler de tes produits favoris" },
          { icon: "🔔", label: "Activation d'alertes par produit", desc: "" },
          { icon: "🎨", label: "Nouvelle palette de couleurs", desc: " — plus douce, moins agressive" },
        ],
      },
      {
        id: "w2-vendeurs",
        emoji: "🏪",
        title: "Pour les vendeurs",
        highlights: [
          { icon: "🏪", label: "Tableau de bord vendeur", desc: " — vue unifiée de vos produits QR et code-barres" },
          { icon: "✏️", label: "Édition rapide", desc: " des informations (prix, stock, statut)" },
          { icon: "🔗", label: "Système de liens vendeur", desc: " pour lier vos infos aux produits scannés" },
        ],
      },
      {
        id: "w2-tech",
        emoji: "🔧",
        title: "Sous le capot",
        highlights: [
          { icon: "🔍", label: "Reconnaissance produit", desc: " via Open Food Facts + EAN-Search en fallback" },
          { icon: "🗺️", label: "Géolocalisation Foursquare", desc: " pour associer chaque scan à un magasin" },
          { icon: "🛡️", label: "Renforcement de l'authentification", desc: ", déduplication des scans" },
        ],
      },
    ],
  },
];

const EvolutionsPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const [open, setOpen] = useState({});

  const toggle = (id) => setOpen(prev => ({ ...prev, [id]: !prev[id] }));

  return (
    <div style={s.wrapper}>
      <div style={s.inner}>
        <BackButton />

        <div style={s.card}>
          <h1 style={s.h1}>📋 Journal des modifications</h1>
          <p style={s.tagline}>
            Toutes les évolutions de CrushNow, racontées simplement.<br />
            Construit en direct, par une équipe de fondateurs passionnés ✨
          </p>
        </div>

        {WAVES.map((wave, wi) => (
          <React.Fragment key={wave.id}>
            {wi > 0 && <hr style={s.separator} />}
            <div style={s.card}>
              <span style={s.waveBadge}>{wave.badge}</span>
              <h2 style={s.waveTitle}>{wave.emoji} {wave.title}</h2>
              <p style={s.waveIntro}>{wave.intro}</p>

              {wave.sections.map((section) => {
                const isOpen = !!open[section.id];
                const hasDetails = section.details && section.details.length > 0;

                return (
                  <div key={section.id}>
                    <p style={s.sectionLabel}>{section.emoji} {section.title}</p>

                    {section.highlights.map((item, hi) => {
                      const isLast = !hasDetails && hi === section.highlights.length - 1;
                      return (
                        <div key={hi} style={isLast ? s.highlightLast : s.highlight}>
                          <span style={{ fontSize: "15px", flexShrink: 0, marginTop: "1px" }}>{item.icon}</span>
                          <span style={s.highlightText}>
                            {item.label ? <><strong>{item.label}</strong>{item.desc}</> : item.desc}
                          </span>
                        </div>
                      );
                    })}

                    {hasDetails && (
                      <>
                        <button
                          style={s.toggleBtn}
                          onClick={() => toggle(section.id)}
                        >
                          <span style={{ ...s.chevron, transform: isOpen ? "rotate(90deg)" : "rotate(0deg)" }}>
                            {">"}
                          </span>
                          {isOpen ? "Masquer les détails" : "Voir tous les détails"}
                        </button>

                        {isOpen && (
                          <div style={s.detailBox}>
                            <ul style={{ margin: "0", paddingLeft: "18px" }}>
                              {section.details.map((d, di) => (
                                <li key={di} style={s.detailItem}>{d}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          </React.Fragment>
        ))}

        <p style={s.footer}>
          Tu remarques quelque chose qui mériterait d'être ajouté ?<br />
          Écris-nous via « Donner mon avis » dans l'app.
        </p>
      </div>
    </div>
  );
};

export default EvolutionsPage;
